<template>
  <div><i class="far fa-asterisk" /> {{ trans("center.requiredField") }}</div>
</template>
